import { render, staticRenderFns } from "./Popups.vue?vue&type=template&id=fca51e06"
import script from "./Popups.vue?vue&type=script&lang=js"
export * from "./Popups.vue?vue&type=script&lang=js"
import style0 from "./Popups.vue?vue&type=style&index=0&id=fca51e06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports